var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 20,
    viewBox: "0 0 21.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposit_icon",
    "data-name": "Deposit icon",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M30.752,36.933v2.03a3.363,3.363,0,0,1-3.57,3.11,3.373,3.373,0,0,1-3.58-3.11v-2.03c0,1.72,1.6,2.94,3.58,2.94S30.752,38.643,30.752,36.933Z",
    transform: "translate(-22 -23.572)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M30.75,34.182a2.623,2.623,0,0,1-.38,1.36,3.675,3.675,0,0,1-3.2,1.58,3.7,3.7,0,0,1-3.2-1.58,2.623,2.623,0,0,1-.38-1.36,2.9,2.9,0,0,1,1.04-2.19,3.817,3.817,0,0,1,2.53-.91,3.869,3.869,0,0,1,2.53.91A2.843,2.843,0,0,1,30.75,34.182Z",
    transform: "translate(-22 -23.572)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M30.752,34.182v2.75c0,1.72-1.6,2.94-3.57,2.94s-3.58-1.23-3.58-2.94v-2.75a3.366,3.366,0,0,1,3.58-3.11,3.869,3.869,0,0,1,2.53.91A2.925,2.925,0,0,1,30.752,34.182Z",
    transform: "translate(-22 -23.572)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M42,31.042V33.1a1.027,1.027,0,0,1-1,1.02H39.04a2.132,2.132,0,0,1-2.16-1.87,2.06,2.06,0,0,1,2.04-2.23H41A1.027,1.027,0,0,1,42,31.042Z",
    transform: "translate(-22 -23.572)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M22,30.572v-2a4.654,4.654,0,0,1,4.19-4.94,5.323,5.323,0,0,1,.81-.06h9a4.573,4.573,0,0,1,.75.05A4.664,4.664,0,0,1,41,28.572v1.45H38.92a2.06,2.06,0,0,0-2.04,2.23,2.132,2.132,0,0,0,2.16,1.87H41v1.45a4.724,4.724,0,0,1-5,5H33.5",
    transform: "translate(-22 -23.572)",
    fill: "none",
    stroke: "#525c75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIc);
export default __webpack_public_path__ + "static/media/deposit-ic.10c2b6b4008955ffd45e9720ed86f1ff.svg";
export { ForwardRef as ReactComponent };